<div class="isg-full-page-header">

  <div class="isg-page-header isg-toolbar">

    <a routerLink="/admin/license"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-table" title="Back to licenses"></span>
    </a>

    <a routerLink="/admin/role"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="far fa-solid fa-gear" title="License Roles"></span>
    </a>

    <a routerLink="/admin/user/permission"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-user-shield" title="User Permissions"></span>
    </a>

    <span>User Maintenance for {{companyName}}</span>


  </div>
  <div class="isg-page-body">

    <kendo-tabstrip id="isgId-usersetup-tabstrip"
                    [style.height.px]="height"
                    (tabSelect)="onTabSelect($event)">

      <kendo-tabstrip-tab title="Users"
                          [selected]="true">
        <ng-template kendoTabContent>
          <div>
            <div class="isg-name-filter">
              <div>Filter by First Name</div>
              <kendo-textbox [(ngModel)]="userStartsWith" />
            </div>
            <div class="isg-toolbar">


              <isg-click-filter [nullable]="true"
                                [textTrue]="'Show Only Licensed Users'"
                                [textNotSpecified]="'Show All Users'"
                                [textFalse]="'Show Users with no License'"
                                [widthForced]="15"
                                [(ngModel)]="userAssigned">

              </isg-click-filter>

              <isg-click-filter [nullable]="true"
                                [textTrue]="'Who are Active'"
                                [textNotSpecified]="'NA'"
                                [textFalse]="'Who are Inactive'"
                                [widthForced]="15"
                                [(ngModel)]="userActive">

              </isg-click-filter>

              <button kendoButton type="button" class="isg-button-label" (click)="onSendEmails($event)">
                <span class="fas fa-envelopes" title="Send access emails out to the checked users"></span>
                Send Access Emails
              </button>
              <span>Access email checkboxes will only show for users that have not logged in</span>

              <button kendoButton
                      type="button"
                      class="isg-button-label isg-ul-download"
                      [disabled]="loadingPanelVisible()"
                      title="Download all users for this license as Excel"
                      (click)="onDownloadUsers($event)">
                <span class="fas fa-file-excel"></span>
                Download Users
              </button>

            </div>

            <app-user-state [licenseId]="currentLicenseId"
                            [companyId]="currentCompanyId"
                            [startsWith]="userStartsWith"
                            [assigned]="userAssigned"
                            [active]="userActive"></app-user-state>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab title="Add Users" *ngIf="hasUserImport() === true">
        <ng-template kendoTabContent>
          <div>

            <app-user-import [licenseId]="currentLicenseId"
                             [companyId]="currentCompanyId"></app-user-import>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>

       </kendo-tabstrip>

    <isg-loader *ngIf="loadingPanelVisible()">
    </isg-loader>

  </div>

</div>
